/**
 * Who runs Nexo, as Spanish law (LSSI and GDPR) requires it on the legal pages. Fields left empty
 * are not shown; fill them in before relying on the pages.
 */
export const legalOwner = {
  name: 'Daniel Jiménez Cabello',
  /** NIF of the owner. */
  taxId: '',
  /** Postal address for legal notices. */
  address: '',
  /** Mailbox for privacy requests (GDPR rights) and legal contact. */
  email: 'privacy@nexo-hub.dev',
  website: 'https://nexo-hub.dev',
  /** Date of the current version of the texts. */
  updatedAt: '2026-10-06',
};
